<main class="min-h-full bg-app-canvas px-4 py-5 pb-28" [ngStyle]="{ 'font-size': fontSize + 'px' }">
  <app-loading *ngIf="isLoading" [background]="'container'" [message]="'載入中...'"></app-loading>
</main>

<app-error [isVisible]="showErrorModal" [errorTitle]="errorTitle" [errorMessage]="errorMessage"
  [showBackButton]="true" [closeOnBackdropClick]="true" (closeError)="onErrorClose()"
  (backRequested)="onBackRequested()"></app-error>
